<template>
    <span class="realtime-visitors">
        <i class="fa fa-spinner fa-spin" v-if="visitors === null"></i>
        <span v-if="visitors">
            {{ visitors }}
        </span>
    </span>
</template>

<script>
    export default {
        props: ['page'],
        data() {
            return {
                visitors: null,
            }
        },
        mounted() {
            this.load();
        },
        computed: {},
        methods: {
            load() {
                var self = this;

                axios.get(route('api.realtime.visitors', {page: this.page}), {}).then(function (response) {
                    self.visitors = response.data;
                }).catch(function (error) {
                    console.log(error);
                });
            }
        },
        watch: {}
    }
</script>
